<template>
  <div>
    <el-dialog
      class="comn_dialog"
      :title="dialogTitle"
      :visible.sync="visible"
      :width="popupWidth"
      :top="popupTop"
      :modal-append-to-body="false"
      :close-on-click-modal="closeModel"
      :append-to-body="appendToBody"
      @close="Cancel"
    >
      <slot>
        <p>弹窗内容自定义</p>
      </slot>
      <span v-show="showBtn" slot="footer" class="dialog-footer">
        <el-button @click="Cancel">取 消</el-button>
        <el-button v-debounce="Save" type="primary">确 定</el-button>
        <div v-show="showTip" class="tip-wrap">
          提交后，可在规格申请菜单查询审核进度，审核通过后才可使用。
        </div>
      </span>
      <span v-show="showCloseBtn" slot="footer" class="dialog-footer">
        <el-button @click="Cancel">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogTitle: {
      type: String,
      default: '标题',
    },
    centerDialogVisible: {
      type: Boolean,
      default() {
        return false;
      },
    },
    popupWidth: {
      type: String,
      default() {
        return '430px';
      },
    },
    popupTop: {
      type: String,
      default() {
        return '23vh';
      },
    },
    showBtn: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showCloseBtn: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showTip: {
      type: Boolean,
      default() {
        return false;
      },
    },
    closeModel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    appendToBody: {
      tyoe: Boolean,
      default() {
        return true;
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.centerDialogVisible;
      },
      set(val) {
        // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit('updateVisible', val);
      },
    },
  },
  methods: {
    Cancel() {
      this.$emit('resetPopupData');
    },
    Save() {
      this.$emit('submitPopupData'); // https://uat-passport.epec.com/sam/
    },
  },
};
</script>
<style lang="scss">
.comn_dialog {
  // .el-dialog__header {
  //   padding: 13px 10px;
  //   border-bottom: 1px solid #EDEDED;
  //   // box-shadow: 0px 4px 4px -4px #d1d0d0;
  //   background: #F5F5F5;
  // }
  // .el-dialog__title {
  //   font-size: 16px;
  //   letter-spacing: 1px;
  //   color: #464646;
  //   font-weight: bolder;
  // }
  .el-dialog__footer {
    padding: 20px 20px 20px 0px;
    text-align: center;
  }
  // .el-dialog__headerbtn {
  //   position: static; // 兼容IE11 ,取消原有的position定位
  // }
  // .el-dialog__close {
  //   // color: $header_bg;
  //   font-size: 20px;
  //   font-weight: bolder;
  //   position: absolute;
  //   top: 16px;
  //   right: 8px;
  //   &::after {
  //     content: '';
  //   //   border: 2px solid $header_bg;
  //     width: 20px;
  //     height: 20px;
  //     border-radius: 25px;
  //     position: absolute;
  //     right: -2px;
  //     top: -3px;
  //   }
  // }
  .el-dialog__body {
    padding: 20px;
  }
  .tip-wrap {
    color: #999;
    font-size: 14px;
    margin-top: 20px;
  }
}
</style>
